package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.MoreVertW500Rounded: ImageVector
    get() {
        if (_moreVertW500Rounded != null) {
            return _moreVertW500Rounded!!
        }
        _moreVertW500Rounded = Builder(name = "MoreVertW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.12f, 811.0f)
                quadToRelative(-34.55f, 0.0f, -59.13f, -24.55f)
                quadToRelative(-24.58f, -24.56f, -24.58f, -59.04f)
                quadToRelative(0.0f, -34.58f, 24.56f, -59.2f)
                quadToRelative(24.55f, -24.62f, 59.03f, -24.62f)
                quadToRelative(34.67f, 0.0f, 59.13f, 24.59f)
                quadToRelative(24.46f, 24.6f, 24.46f, 59.13f)
                quadToRelative(0.0f, 34.54f, -24.46f, 59.11f)
                quadTo(514.67f, 811.0f, 480.12f, 811.0f)
                close()
                moveTo(480.12f, 563.59f)
                quadToRelative(-34.55f, 0.0f, -59.13f, -24.56f)
                quadToRelative(-24.58f, -24.55f, -24.58f, -59.03f)
                quadToRelative(0.0f, -34.67f, 24.56f, -59.13f)
                quadToRelative(24.55f, -24.46f, 59.03f, -24.46f)
                quadToRelative(34.67f, 0.0f, 59.13f, 24.46f)
                reflectiveQuadToRelative(24.46f, 59.01f)
                quadToRelative(0.0f, 34.55f, -24.46f, 59.13f)
                quadToRelative(-24.46f, 24.58f, -59.01f, 24.58f)
                close()
                moveTo(480.12f, 316.41f)
                quadToRelative(-34.55f, 0.0f, -59.13f, -24.64f)
                quadToRelative(-24.58f, -24.64f, -24.58f, -59.25f)
                reflectiveQuadToRelative(24.56f, -59.06f)
                quadTo(445.52f, 149.0f, 480.0f, 149.0f)
                quadToRelative(34.67f, 0.0f, 59.13f, 24.46f)
                quadToRelative(24.46f, 24.45f, 24.46f, 59.06f)
                reflectiveQuadToRelative(-24.46f, 59.25f)
                quadToRelative(-24.46f, 24.64f, -59.01f, 24.64f)
                close()
            }
        }
        .build()
        return _moreVertW500Rounded!!
    }

private var _moreVertW500Rounded: ImageVector? = null
